import { render } from "./ProductParallax.vue?vue&type=template&id=0da518ab&scoped=true"
import script from "./ProductParallax.vue?vue&type=script&lang=js"
export * from "./ProductParallax.vue?vue&type=script&lang=js"

import "./ProductParallax.vue?vue&type=style&index=0&id=0da518ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da518ab"]])

export default __exports__